
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'oxd-form-row',

  computed: {
    classes() {
      return {
        'oxd-form-row': true,
      };
    },
  },
});
